import React from 'react';

const SectionEyebrow = ({ children, icon: Icon, className = '' }) => (
  <span className={`section-eyebrow ${className}`}>
    {Icon ? <Icon className="h-3.5 w-3.5" aria-hidden="true" /> : null}
    {children}
  </span>
);

export default SectionEyebrow;
